module.exports = __webpack_public_path__ + "img/ic_homestay_apply_item_img2.83a42213.png";